import { requestJson } from "./apiClient";

const BASE = "/api/public/transport";

function buildSearch(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, String(value));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

export async function fetchPublicTransportNeighborhoods(options = {}) {
  return requestJson(`${BASE}/neighborhoods`, { signal: options.signal });
}

export async function fetchPublicTransportNeighborhood(slug, params = {}, options = {}) {
  return requestJson(`${BASE}/neighborhoods/${encodeURIComponent(slug)}${buildSearch(params)}`, {
    signal: options.signal,
  });
}

export async function fetchPublicTransportMetroStation(slug, options = {}) {
  return requestJson(`${BASE}/metro/${encodeURIComponent(slug)}`, { signal: options.signal });
}

export async function fetchPublicTransportAccess(slug, options = {}) {
  return requestJson(`${BASE}/access/${encodeURIComponent(slug)}`, { signal: options.signal });
}

export async function fetchPublicTransportCommunityReports(params = {}, options = {}) {
  return requestJson(`${BASE}/community-reports${buildSearch(params)}`, { signal: options.signal });
}

export async function fetchPublicClientViewTransportLanding(clientViewKey, options = {}) {
  return requestJson(`${BASE}/client-views/${encodeURIComponent(clientViewKey)}/transport`, {
    signal: options.signal,
  });
}

export async function fetchPublicTransportSitemapData(options = {}) {
  return requestJson(`${BASE}/seo/sitemap-data`, { signal: options.signal });
}

export async function fetchAdminTransportPublicSettings(options = {}) {
  return requestJson("/api/admin/transport/public-settings", { signal: options.signal });
}

export async function patchAdminTransportPublicSettings(body, options = {}) {
  return requestJson("/api/admin/transport/public-settings", {
    method: "PATCH",
    body: JSON.stringify(body),
    headers: { "Content-Type": "application/json" },
    signal: options.signal,
  });
}
